import { AddNewButtonModal } from "./AddNewHardware/AddNewHarwarePresenter"
import HardwareListPresenter from "./HardwareList/HardwareListPresenter"

export const HardwareList = {
    List : HardwareListPresenter,
    AppNewButtonModal: AddNewButtonModal
}

export default HardwareList